// src/authorization-errors.ts
var REVERIFICATION_REASON = "reverification-error";
var reverificationError = (missingConfig) => ({
  clerk_error: {
    type: "forbidden",
    reason: REVERIFICATION_REASON,
    metadata: {
      reverification: missingConfig
    }
  }
});
var reverificationErrorResponse = (...args) => new Response(JSON.stringify(reverificationError(...args)), {
  status: 403
});
var isReverificationHint = (result) => {
  var _a, _b;
  return result && typeof result === "object" && "clerk_error" in result && ((_a = result.clerk_error) == null ? void 0 : _a.type) === "forbidden" && ((_b = result.clerk_error) == null ? void 0 : _b.reason) === REVERIFICATION_REASON;
};

export {
  reverificationError,
  reverificationErrorResponse,
  isReverificationHint
};
//# sourceMappingURL=chunk-5C3LHKBE.mjs.map